import axios from 'axios';
import { trackEvent } from './Telemetry/telemetry.service';

const successIntercept = response => response;
const errorIntercept = error => {
	trackEvent(`Error: ${error.config.method}`);
	trackEvent(`Error Status: ${error.response.status}`);
	trackEvent(`Error Text: ${error.response.statusText}`);
	trackEvent(`Error Url: ${error.config.url.split('?')[0]}`);
	return Promise.reject(error);
};

const instance = axios.create({
	// .. where we make our configurations
		baseURL: process.env.REACT_APP_BASEURL
	});
instance.interceptors.response.use(successIntercept, errorIntercept);

export default instance;